import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/">
            <Button variant="ghost">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
          </Link>
        </div>
      </header>
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-slate-900 mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Privacy Policy
        </h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-sm text-slate-500 mb-8">Last updated: January 2025</p>
          
          <h2>1. Introduction</h2>
          <p>
            Robert Elder III ("Company," "we," "us," or "our") respects your privacy and is committed 
            to protecting your personal data. This Privacy Policy explains how we collect, use, and 
            safeguard your information when you use CareerBoost, BizPlanAI, CreditBoost, or any 
            related services.
          </p>

          <h2>2. Information We Collect</h2>
          <h3>Information You Provide:</h3>
          <ul>
            <li>Account information (name, email, password)</li>
            <li>Payment information (processed securely via Stripe)</li>
            <li>Resume and career information (for CareerBoost)</li>
            <li>Business information (for BizPlanAI)</li>
            <li>Credit profile information (for CreditBoost)</li>
          </ul>
          
          <h3>Automatically Collected Information:</h3>
          <ul>
            <li>Device and browser information</li>
            <li>IP address and location data</li>
            <li>Usage patterns and preferences</li>
          </ul>

          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and improve our Services</li>
            <li>Generate personalized AI content</li>
            <li>Process payments</li>
            <li>Communicate with you about your account</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your data. Payment information 
            is processed through Stripe and is never stored on our servers. However, no method of 
            transmission over the Internet is 100% secure.
          </p>

          <h2>5. Data Retention</h2>
          <p>
            We retain your data for as long as your account is active or as needed to provide Services. 
            You may request deletion of your data at any time by contacting us.
          </p>

          <h2>6. Third-Party Services</h2>
          <p>We use the following third-party services:</p>
          <ul>
            <li><strong>Stripe:</strong> Payment processing</li>
            <li><strong>OpenAI:</strong> AI content generation</li>
            <li><strong>MongoDB:</strong> Data storage</li>
          </ul>
          <p>These services have their own privacy policies governing their use of your data.</p>

          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Delete your data</li>
            <li>Export your data</li>
            <li>Opt out of marketing communications</li>
          </ul>

          <h2>8. Children's Privacy</h2>
          <p>
            Our Services are not intended for children under 18. We do not knowingly collect 
            information from children under 18.
          </p>

          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes 
            by posting the new policy on this page.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            For questions about this Privacy Policy, please contact:<br />
            Robert Elder III<br />
            Founder & CEO<br />
            Email: privacy@careerboost.com
          </p>

          <div className="mt-12 p-6 bg-slate-100 rounded-xl">
            <p className="font-semibold text-slate-900">
              © 2024-2025 Robert Elder III. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
